var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gradient-strip"},_vm._l((_vm.count ?? _vm.stripCount),function(n){return _c('span',{key:n,style:({ width: `${_vm.width ?? _vm.stripWidth}px` })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }